import { IResponse } from 'src/interface';
import { getWithPath, getWithUrl } from 'src/utils/http';

export const CommonService = {
    getWeatherList(): Promise<IResponse<any>> {
        return getWithPath(
            '/slave/widget/weather/get/board'
        );
    },

    getWeatherDetail(boardId: string): Promise<IResponse<any>> {
        return getWithPath(
            `/slave/widget/weather/get/info`, {
            boardId
        }
        );
    },

    getCurrencyList(): Promise<IResponse<any>> {
        return getWithPath('/slave/widget/currency/get/boards');
    },

    getStockList(): Promise<IResponse<any>> {
        return getWithPath('/slave/widget/stock/get/boards');
    },

    getGoldList(): Promise<IResponse<any>> {
        return getWithPath('/slave/widget/gold/get/boards');
    },

    getCountNewContent(time: number): Promise<IResponse<any>> {
        return getWithUrl(
            'https://api.baomoi.com/v1/webs/get/content-notify-new',
            { from_time: time }
        );
    },
};

export default { CommonService };
